<template>
    <nav class="sub-pages" v-if="current_page_id && pages.length !== 0">
        <h3 @click="active = !active">
            <!-- <span v-if="!active && current_page.post_title" v-html="current_page.post_title"></span>
            <span v-else v-html="pages[0].post_title"></span> -->
            <!-- <span v-if="current_page && current_page.post_title" v-html="current_page.post_title"></span> -->

            <span v-for="page in pages" :key="page.ID" v-if="page.ID === current_page_id" v-html="page.post_title"></span>
        </h3>
        <slide-up-down :active="active" :duration="300">
            <ul>
                <li v-for="(page, index) in pages" :key="index" :class="['menu-item-' + page.slug]">
                    <Link :post_link="page.link">
                        <h3 v-if="page.post_title === 'MIMA Online Shop'">All products</h3>
                        <h3 v-else v-html="page.post_title"></h3>
                    </Link>
                </li>
            </ul>
        </slide-up-down>


    </nav>
</template>

<script>
import Link from '@/components/ui/Link.vue';

export default {
    name: 'sub-pages',

    watch: {
        '$route.params': {
            handler(params) {
                this.active = false;
            },

            immediate: true,
        }
    },

    components: {
        Link,
    },

    data() {
        return {
            active: false,
            current_page: '',
        }
    },

    props: {
        current_page_id: {
            type: Number,
            default: 0,
        },
        pages: {
            type: Array,
            default: [],
        },
    },

    // mounted() {
    //     // console.log(this.pages, this.current_page_id)

    //     console.log(this.current_page_id)
    //     // setTimeout(() => {

    //     // let current_page = this.pages.filter((p) => p.ID === this.current_page_id);
    //     // this.current_page = current_page[0];
    //     // }, 100);

    // },
}

</script>

<style lang="scss">
    .sub-pages {
        padding: var(--padding-50) var(--padding) 0;
        margin: 0 0 var(--padding);

        &.shop-menus {
            margin-bottom: var(--padding-50);
            
            & > h3 {
                background: var(--orange);
            }
        }

        & > h3 {
            cursor: pointer;
            padding: 0 var(--padding-25) ;
            background: var(--yellow);
            font-size: var(--title-size);
            position: relative;
            z-index: 3;

            &::before {
                content: "▼";
                float: right;
                position: relative;
                font-size: calc(var(--title-size) - .5rem);
                padding-top: .5rem;
            }
        }

        ul {
            padding: 0 var(--padding-x2) 0;

            li {
                height: 5.5rem;
                position: relative;
                margin-top: calc(var(--line) * -1);

                a {
                    display: block;
                    font-size: var(--title-size);
                    background: white;
                    padding: 0 var(--padding-25);
                    position: absolute;
                    border: var(--line) solid var(--font-color);
                    height: 5.5rem;
                    width: 100%;
                    line-height: 5rem;
                    // transform: translateZ(0);
                    // transition: all .2s ease;
                    box-sizing: border-box;

                    &::before {
                        content: '→';
                        float: right;
                    }


                    &:hover {
                        z-index: 19;
                        opacity: 1;
                        // transform: scale(1.05);
                        font-size: calc(var(--title-size) + .75rem);
                        height: 8rem;
                        line-height: 8rem;
                        margin: -2rem 0 0 -3rem;
                        width: calc(var(--padding-x2) + 100%);
                        text-decoration: none;
                    }
                }

                &.menu-item-donate a {
                    color: var(--orange);
                }

                &.menu-item-shipping-and-returns a {
                    color: var(--gray);
                }
            }
        }
    }

    @media only screen and (max-width: 767px) {
        .sub-pages {
            padding: 0 var(--padding) 0;


            ul {
                padding: 0 var(--padding) 0;

                li {
                    height: auto;
                    position: relative;

                    a {
                        font-size: var(--large-size);
                        padding: var(--padding-50) var(--padding);
                        position: relative;
                        height: auto;
                        width: 100%;
                        line-height: initial;

                        &:hover {
                            font-size: var(--large-size);
                            height: auto;
                            line-height: initial;
                            margin: 0;
                            width: 100%;
                        }
                    }
                }
            }
        }
    }
</style>